export default __webpack_public_path__ + "static/media/CIA-ALTERNATIVE-ENERGY-JUNE2025.ad8b22d8.pdf";